import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const MaturityBannerStyle = makeStyles((theme) => ({
	banner: (props) => ({
		width: 12,
		height: 12,
		borderRadius: "50%",
		backgroundColor: props.color,
		display: "inline-block",
	}),
}));

export default MaturityBannerStyle;
